import { IPackageListingState, IEventFilter, defaultPackageListingModel } from '../../classes/package-listing';
import { IProduction, IPerformanceGroup, IPackage, IPerformancePricing, IPerformance } from '../../custom/classes/production';

import { ActionType, IPackageListingStateAction } from '../../classes/package-listing-actions';

import { filterMap } from '../../helpers/map-helpers';

import { cloneDeep } from 'lodash';
import { generateEventFilter } from '../../helpers/filter-by-query';
/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function packageListingReducer(state: IPackageListingState<IPackage> = defaultPackageListingModel, action: IPackageListingStateAction) {
    switch (action.type) {
        case ActionType.LoadPackage: {
            return { ...state, packageDetail: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.LoadPackages: {           
            if (window.location.search !== "") {
                let queryStringFilters: IEventFilter[] = new Array();
                decodeURI(window.location.search)
                    .replace('?', '')
                    .split('&')
                    .map(param => param.split('='))
                    .map(filters => {
                        const filter: IEventFilter = {
                            key: filters[0],
                            selectedValue: filters[1],
                            filter: generateEventFilter(filters[0], filters[1])
                        }
                        queryStringFilters.push(filter);
                    });
                return { ...state, packages: action.value, eventFilter: queryStringFilters } as IPackageListingState<IPackage>;
            }
            else {
                return { ...state, packages: action.value } as IPackageListingState<IPackage>;
            }
        }
        case ActionType.UpdatePerformancesFilter: {
            const updating = true;
            const addedFilterFunction = action.value;
            let eventFilter: IEventFilter[] = null;
            if (state.eventFilter.some(filter => { return filter.key === addedFilterFunction.key })) {
                eventFilter = state.eventFilter.filter(filter => !(filter.key === addedFilterFunction.key)).concat([addedFilterFunction]);
            } else {
                eventFilter = state.eventFilter.concat([addedFilterFunction])
            }
            const filterFunction = (event) => eventFilter.map(fil => {
                return fil.filter;
            }).every(f => f(event));

            const currentPage = window.location.origin + window.location.pathname;
            let filterQuery = "";
            eventFilter.forEach(filter => {
                if (filterQuery === "") {
                    filterQuery = "?" + filter.key + "=" + filter.selectedValue;
                } else {
                    filterQuery += "&" + filter.key + "=" + filter.selectedValue;
                }
            })
            window.history.pushState({ path: currentPage + filterQuery }, '', currentPage + filterQuery);

            return { ...state, eventFilter, filterFunction, updating } as IPackageListingState<IPackage>;
        }

        case ActionType.RemovePerformancesFilter: {
            const eventFilter = state.eventFilter.filter(filter => filter.key !== action.value);
            const filterFunction = (event: IProduction) => eventFilter.map(filter => filter.filter).every(func => func(event));

            return { ...state, eventFilter, filterFunction, updating: true } as IPackageListingState<IPackage>;
        }

        case ActionType.RemoveAllPerformancesFilters: {
            return { ...state, eventFilter: [], filterFunction: (event: IProduction) => true, updating: true } as IPackageListingState<IPackage>;
        }

        case ActionType.UpdateOrderNotes: {
            return { ...state, orderNotes: action.value } as IPackageListingState<IPackage>;
        }

        case ActionType.UpdateSeatingChoice: {
            let updatedSeatingChoice = [...state.seatingChoice];
            const indexOfSeat = state.seatingChoice.indexOf(action.value);
            if (indexOfSeat >= 0)
                updatedSeatingChoice = updatedSeatingChoice.splice(indexOfSeat, indexOfSeat);
            else
                updatedSeatingChoice.push(action.value);

            return { ...state, seatingChoice: updatedSeatingChoice } as IPackageListingState<IPackage>;
        }

        case ActionType.AddItemToCart: {
            let updatedMap = state.cartItems.set(action.value.itemId, 0);

            if (action.value.packageId) {
                let addedSubPackages = state.subPackagesInCart.get(action.value.packageId);

                let updatedSubPackageList = [...action.value.itemId];

                if (addedSubPackages) {
                    updatedSubPackageList = addedSubPackages.concat(updatedSubPackageList);
                }
                var updatedSubPackageMap = state.subPackagesInCart.set(action.value.packageId, updatedSubPackageList)
            }
            return { ...state, cartItems: updatedMap, subPackagesInCart: updatedSubPackageMap ? updatedSubPackageMap: state.subPackagesInCart } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdateSeatingPreferences: {
            return { ...state, seatingPreferences: action.value } as IPackageListingState<IPackage>;
        }



        case ActionType.RemoveItemFromCart: {

            const matchedSuperPackage = state.subPackagesInCart.get(action.value);
            if (matchedSuperPackage) {
                let newPerfs = filterMap(state.cartItems, cartItem => matchedSuperPackage.indexOf(cartItem) < 0);
                let newSubPackageList = filterMap(state.subPackagesInCart, cartItem => cartItem !== action.value)
                return { ...state, cartItems: newPerfs, subPackagesInCart: newSubPackageList } as IPackageListingState<IPackage>;

            } else {
                let newPerfs = filterMap(state.cartItems, cartItem => cartItem !== action.value);
                return { ...state, cartItems: newPerfs } as IPackageListingState<IPackage>;

            }
        }

        case ActionType.PerformancesUpdated: {
            return { ...state, updating: false } as IPackageListingState<IPackage>;
        }
        case ActionType.BrowserNavigated: {
            state = action.value.state;
            return state as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePriceTypeQuantity: {
            state.priceTypeQuantity.set(action.value.priceTypeId, action.value.quantity);
            const ticketSum = Array.from(state.priceTypeQuantity.values()).reduce((total, num) => total + num, 0);
            return { ...state, totalNumberOfTicket: ticketSum } as IPackageListingState<IPackage>;
        }
        case ActionType.SetOriginalSeatQuantity: {
            const ticketSum = Array.from(state.priceTypeQuantity.values()).reduce((total, num) => total + num, 0);
            return { ...state, originalSeatQuantity: ticketSum } as IPackageListingState<IPackage>;
        }
        case ActionType.SetOriginalSeats: {
            return { ...state, originalSeats: action.value.originalSeats }
        }
        case ActionType.ClearPriceTypeQuantities: {
            state.priceTypeQuantity.clear();
            let defaultNumberOfTickets = 0;

            if (state.packageDetail != null && state.packageDetail.packagePriceTypes.length == 1) {
                defaultNumberOfTickets = 1;
                state.priceTypeQuantity.set(state.packageDetail.packagePriceTypes[0].priceTypeId, 1);
            }

            return { ...state, totalNumberOfTicket: defaultNumberOfTickets, priceTypeQuantity: new Map<number, number>() } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePackageProcessing: {
            return { ...state, processing: true, errorMessages: [] } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePackageProcessingErrors: {
            return { ...state, processing: false, errorMessages: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.ReceivePerformancePricing: {
            const perfPricing: IPerformancePricing = action.value;

            let newList = state.performancePricingList.set(perfPricing.performanceId, perfPricing);

            return { ...state, performancePricingList: newList } as IPackageListingState<IPackage>;

        }
        case ActionType.ReceivePackagePricing: {
            const packagePricing = action.value;

            let newList = state.performancePricingList.set(packagePricing.packageId, packagePricing);

            return { ...state, performancePricingList: newList } as IPackageListingState<IPackage>;

        }
        case ActionType.UpdateSelectedZone: {
            let matchedPerf = filterMap(state.cartItems, p => p === action.value.itemId);
            state.cartItems.set(matchedPerf.keys().next().value, action.value.zoneId);
            let newPerfs = cloneDeep(state.cartItems);

            return { ...state, cartItems: newPerfs } as IPackageListingState<IPackage>;

        }

        case ActionType.RemoveSelectedZone: {
            let matchedItem = filterMap(state.cartItems, p => p === action.value);
            state.cartItems.set(matchedItem.keys().next().value, 0);
            let newPerfs = cloneDeep(state.cartItems);

            return { ...state, cartItems: newPerfs } as IPackageListingState<IPackage>;

        }

        //case ActionType.UpdatePackageZone: {

        //    return { ...state, packageInCart: state.packageInCart.set(state.packageInCart.keys().next().value, action.value.zoneId) } as IPackageListingState<IPackage>;

        //}

        //case ActionType.RemovePackageZone: {
        //    return { ...state, packageInCart: state.packageInCart.set(state.packageInCart.keys().next().value, 0) } as IPackageListingState<IPackage>;

        //}

        case ActionType.ToggleMiniCart: {
            return { ...state, miniCartOpen: action.value } as IPackageListingState<IPackage>;

        }
        default:
            return state;
    }
}
